import React, { useCallback } from 'react';
import { createPrefixCls } from '../_utils/string';
import PickerCol from './picker-col';
const prefixCls = createPrefixCls('picker');
export const SinglePicker = ({ data, defaultValue, onChange }) => {
    const handleSingleChange = useCallback((index) => {
        onChange && onChange(data[index], 0);
    }, [data, onChange]);
    return (React.createElement("div", { className: prefixCls('content') },
        React.createElement("div", { className: prefixCls('mask') }),
        React.createElement("div", { className: prefixCls('indicator') }),
        React.createElement(PickerCol, { data: data, value: defaultValue, onChange: handleSingleChange })));
};
export default SinglePicker;
